import ajax from '../../lib/ajax'
export async function GetCenterCostByPayType(payload:any) {
    let res = await ajax.get('api/services/app/ReportForm/GetCenterCostByPayType',{params:payload},false)
    return res.data.result
}
export async function GetCenterCostByStatisticalClass(payload:any) {
    let res = await ajax.get('api/services/app/ReportForm/GetCenterCostByStatisticalClass',{params:payload},false)
    return res.data.result
}
export async function GetCenterCostSummaryByPayType(payload:any) {
    let res = await ajax.get('api/services/app/ReportForm/GetCenterCostSummaryByPayType',{params:payload},false)
    return res.data.result
}
export async function GetCenterCostSummaryByStatisticalClass(payload:any) {
    let res = await ajax.get('api/services/app/ReportForm/GetCenterCostSummaryByStatisticalClass',{params:payload},false)
    return res.data.result
}
export async function GetCenterCostDetail(payload:any) {
    let res = await ajax.get('api/services/app/ReportForm/GetCenterCostDetail',{params:payload},false)
    return res.data.result
}
export async function GetPrePaymentDetail(payload:any) {
    let res = await ajax.get('api/services/app/ReportForm/GetPrePaymentDetail',{params:payload},false)
    return res.data.result
}
export async function GetPrePaymentBalance(payload:any) {
    let res = await ajax.get('api/services/app/ReportForm/GetPrePaymentBalance',{params:payload},false)
    return res.data.result
}
export async function GetCreditDetail(payload:any) {
    let res = await ajax.get('api/services/app/ReportForm/GetCreditDetail',{params:payload},false)
    return res.data.result
}
export async function GetCreditBalanceDetail(payload:any) {
    let res = await ajax.get('api/services/app/ReportForm/GetCreditBalanceDetail',{params:payload},false)
    return res.data.result
}
export async function QueryPatient(payload:any) {
    let res = await ajax.post('api/services/app/ReportForm/QueryPatient',{},false)
    return res.data.result
}
export async function QueryUserByType(payload:any) {
    let res = await ajax.get('api/services/app/ReportForm/QueryUserByType',{params:payload},false)
    return res.data.result
}
export async function GetChargeSumReport(payload:any) {
    let res = await ajax.get('api/services/app/ReportForm/GetChargeSumReport',{params:payload},true)
    return res.data.result
}